import {
  DAILY_CREDIT_TEST_GROUP_ID,
  DAILY_CREDIT_TEST_MP_PROPERTY,
} from "./dailyCreditExperiment";
import {
  SIGNUP_BONUS_TEST_GROUP_ID,
  SIGNUP_BONUS_TEST_MP_PROPERTY,
} from "./signupBonusExperiment";

/**
 * A/B tests whose group is mirrored in localStorage. getMixpanelContextHeaders
 * forwards the whole registry as the `x-mp-test-groups` header, which the
 * backend `$set_once`s onto the user profile and stamps on its own events.
 * Adding or retiring a test is one line here — see RETIRE.md.
 *
 * Two kinds end up here, differing only in who decides the group:
 *
 *  - **Client-assigned** — bucketed in the browser, because the variant
 *    decides routing or UI before the user is identified. The primitives are
 *    in settings.ts (`getOrAssignWeightedTestGroup` and friends).
 *  - **Backend-assigned, browser-mirrored** — the backend buckets the user and
 *    we learn the group from `/profile`, then copy it into localStorage so the
 *    same header carries it.
 */
export const CLIENT_EXPERIMENTS: { storageKey: string; property: string }[] = [
  {
    storageKey: DAILY_CREDIT_TEST_GROUP_ID,
    property: DAILY_CREDIT_TEST_MP_PROPERTY,
  },
  {
    storageKey: SIGNUP_BONUS_TEST_GROUP_ID,
    property: SIGNUP_BONUS_TEST_MP_PROPERTY,
  },
];
